<div mat-dialog-title>
    <img src="../../assets/postAd/success.jpeg" style="width: 250px; margin-left: 15%;">
    <h1 style="    margin-left: 33%;">Thank You!</h1>
    <h3>Your advertisement has been successfully published.</h3>
</div>
